// DuckSignals Contract ABI - For on-chain agent data
// Contract: DuckSignals.sol on Monad Mainnet

export const DUCK_SIGNALS_ADDRESS = import.meta.env.VITE_DUCK_SIGNALS_ADDRESS || '0x0000000000000000000000000000000000000000';

export const DUCK_SIGNALS_ABI = [
    // Agent Registration
    {
        inputs: [{ name: 'name', type: 'string' }],
        name: 'registerAgent',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    // Post Trading Signal
    {
        inputs: [
            { name: 'signalType', type: 'string' },
            { name: 'confidence', type: 'uint256' },
            { name: 'price', type: 'uint256' },
            { name: 'reason', type: 'string' },
        ],
        name: 'postSignal',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    // Post Prediction
    {
        inputs: [
            { name: 'direction', type: 'string' },
            { name: 'confidence', type: 'uint256' },
            { name: 'referencePrice', type: 'uint256' },
            { name: 'targetTime', type: 'uint256' },
        ],
        name: 'postPrediction',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    // Get Agent Count
    {
        inputs: [],
        name: 'getAgentCount',
        outputs: [{ name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    // Get All Agents
    {
        inputs: [],
        name: 'getAllAgents',
        outputs: [{ name: '', type: 'address[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    // Get Recent Signals
    {
        inputs: [{ name: 'count', type: 'uint256' }],
        name: 'getRecentSignals',
        outputs: [
            {
                components: [
                    { name: 'agent', type: 'address' },
                    { name: 'signalType', type: 'string' },
                    { name: 'confidence', type: 'uint256' },
                    { name: 'price', type: 'uint256' },
                    { name: 'reason', type: 'string' },
                    { name: 'timestamp', type: 'uint256' },
                ],
                name: '',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    // Get Recent Predictions
    {
        inputs: [{ name: 'count', type: 'uint256' }],
        name: 'getRecentPredictions',
        outputs: [
            {
                components: [
                    { name: 'agent', type: 'address' },
                    { name: 'direction', type: 'string' },
                    { name: 'confidence', type: 'uint256' },
                    { name: 'referencePrice', type: 'uint256' },
                    { name: 'targetTime', type: 'uint256' },
                    { name: 'verified', type: 'bool' },
                    { name: 'correct', type: 'bool' },
                    { name: 'timestamp', type: 'uint256' },
                ],
                name: '',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    // Get Agent Stats
    {
        inputs: [{ name: 'agent', type: 'address' }],
        name: 'agents',
        outputs: [
            { name: 'name', type: 'string' },
            { name: 'totalSignals', type: 'uint256' },
            { name: 'totalPredictions', type: 'uint256' },
            { name: 'correctPredictions', type: 'uint256' },
            { name: 'lastActive', type: 'uint256' },
            { name: 'isRegistered', type: 'bool' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    // Get Latest Signal for Agent
    {
        inputs: [{ name: 'agent', type: 'address' }],
        name: 'latestSignal',
        outputs: [
            { name: 'agent', type: 'address' },
            { name: 'signalType', type: 'string' },
            { name: 'confidence', type: 'uint256' },
            { name: 'price', type: 'uint256' },
            { name: 'reason', type: 'string' },
            { name: 'timestamp', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    // Get Total Signals
    {
        inputs: [],
        name: 'getTotalSignals',
        outputs: [{ name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    // Get Total Predictions
    {
        inputs: [],
        name: 'getTotalPredictions',
        outputs: [{ name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    // Get Agent Accuracy
    {
        inputs: [{ name: 'agent', type: 'address' }],
        name: 'getAgentAccuracy',
        outputs: [{ name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    // Events
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: 'agent', type: 'address' },
            { indexed: false, name: 'name', type: 'string' },
        ],
        name: 'AgentRegistered',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: 'agent', type: 'address' },
            { indexed: false, name: 'signalType', type: 'string' },
            { indexed: false, name: 'confidence', type: 'uint256' },
            { indexed: false, name: 'price', type: 'uint256' },
        ],
        name: 'SignalPosted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: 'agent', type: 'address' },
            { indexed: false, name: 'direction', type: 'string' },
            { indexed: false, name: 'confidence', type: 'uint256' },
        ],
        name: 'PredictionPosted',
        type: 'event',
    },
] as const;
